/**
 * Det aktive firma (kundevisning > eget firma) — bruges af priser, kurv m.m.
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase/client";
import { useActiveCompanyId } from "@/features/sales/ImpersonationContext";
import type { Tables } from "@/lib/supabase/database.types";

export type Company = Tables<"companies">;

export function useCompanyById(companyId: string | null | undefined) {
  return useQuery({
    queryKey: ["firma", companyId],
    queryFn: async (): Promise<Company | null> => {
      if (!companyId) return null;
      const { data, error } = await supabase
        .from("companies")
        .select("*")
        .eq("id", companyId)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    enabled: !!companyId,
  });
}

export function useActiveCompany() {
  const companyId = useActiveCompanyId();
  return { companyId, ...useCompanyById(companyId) };
}

/** Profil for firmaets tilknyttede sælger (RLS tillader opslag af egen sælger). */
export function useSalespersonProfile(salespersonUserId: string | null | undefined) {
  return useQuery({
    queryKey: ["saelgerprofil", salespersonUserId],
    queryFn: async () => {
      if (!salespersonUserId) return null;
      const { data, error } = await supabase
        .from("profiles")
        .select("user_id, name, last_name, email, phone, avatar_url")
        .eq("user_id", salespersonUserId)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    enabled: !!salespersonUserId,
  });
}
